import request from '../utils/request'

// ==================== 认证相关 ====================
export function login(data) {
  return request({ url: '/auth/login', method: 'post', data })
}

export function register(data) {
  return request({ url: '/auth/register', method: 'post', data })
}

export function getUserInfo() {
  return request({ url: '/user/info', method: 'get' })
}

export function logout() {
  return request({ url: '/auth/logout', method: 'post' })
}

// ==================== 短信服务 ====================
export function getServices(params) {
  return request({ url: '/services', method: 'get', params })
}

export function getCountries(params) {
  return request({ url: '/countries', method: 'get', params })
}

export function buySms(data) {
  return request({ url: '/sms/buy', method: 'post', data })
}

export function getSms(params) {
  return request({ url: '/sms/get', method: 'get', params })
}

export function cancelOrder(data) {
  return request({ url: '/sms/cancel', method: 'post', data })
}

export function getOrders(params) {
  return request({ url: '/sms/orders', method: 'get', params })
}

export function buyPremiumSms(data) {
  return request({ url: '/sms/premium/buy', method: 'post', data })
}

// ==================== 号码租用 ====================
export function rentNumber(data) {
  return request({ url: '/numbers/rent', method: 'post', data })
}

export function getRentedNumbers(params) {
  return request({ url: '/numbers/rented', method: 'get', params })
}

export function returnNumber(data) {
  return request({ url: '/numbers/return', method: 'post', data })
}

// ==================== eSIM ====================
export function getEsimPlans(params) {
  return request({ url: '/esim/plans', method: 'get', params })
}

export function buyEsim(data) {
  return request({ url: '/esim/buy', method: 'post', data })
}
export function updateChannel(data) {
  return request({ url: '/chat/update-channel', method: 'post', data })
}
// ==================== 用户/支付 ====================
export function getBalance() {
  return request({ url: '/user/balance', method: 'get' })
}

export function recharge(data) {
  return request({ url: '/payment/recharge', method: 'post', data })
}

export function getRechargeHistory(params) {
  return request({ url: '/payment/history', method: 'get', params })
}

export function getRechargeOrderStatus(params) {
  return request({ url: '/payment/order-status', method: 'get', params })
}

export function getApiKey() {
  return request({ url: '/api/key', method: 'get' })
}

export function getLoyaltyInfo() {
  return request({ url: '/loyalty', method: 'get' })
}

export function getEarnInfo() {
  return request({ url: '/earn', method: 'get' })
}

// ==================== 文章/博客 ====================
export function getArticles(params) {
  return request({ url: '/articles', method: 'get', params })
}

export function getArticle(id) {
  return request({ url: '/article/detail', method: 'get', params: { id } })
}

export function getArticleCategories() {
  return request({ url: '/article/categories', method: 'get' })
}

// ==================== 反馈 ====================
export function submitFeedback(data) {
  return request({ url: '/feedback', method: 'post', data })
}

// ==================== 在线客服 ====================
export function getChatSessions(params) {
  return request({ url: '/chat/sessions', method: 'get', params })
}

export function getChatMessages(params) {
  return request({ url: '/chat/messages', method: 'get', params })
}

export function sendChatMessage(data) {
  return request({ url: '/chat/send', method: 'post', data })
}

export function getReceptionRecords(params) {
  return request({ url: '/chat/records', method: 'get', params })
}

export function getChatPlans() {
  return request({ url: '/chat/plans', method: 'get' })
}

export function getChatSubscription() {
  return request({ url: '/chat/subscription', method: 'get' })
}

// 上传图片（公开接口，无需登录）
export function uploadChatImage(data) {
  return request({ url: '/upload/chat-image', method: 'post', data })
}

export function buyChatPlan(data) {
  return request({ url: '/chat/buy-plan', method: 'post', data })
}
export function getChatRenewalHistory(params) {
  return request({ url: '/chat/renewal-history', method: 'get', params })
}
export function sendVerifyCode(data) {
  return request({ url: '/auth/send-code', method: 'post', data })
}
export function autoRenewxufeipost(data) {
  return request({ url: '/chat/autoRenewxufei', method: 'post', data })
}
export function getMyChannel() {
  return request({ url: '/chat/my-channel', method: 'get' })
}

export function getChannelSessions(params) {
  return request({ url: '/chat/channel-sessions', method: 'get', params })
}

export function recallChatMessage(data) {
  return request({ url: '/chat/recall', method: 'post', data })
}

export function markChatRead(data) {
  return request({ url: '/chat/mark-read', method: 'post', data })
}

// ==================== 彩票 ====================
export function getLotteryTypes() {
  return request({ url: '/lottery/types', method: 'get' })
}

export function getLotteryResults() {
  return request({ url: '/lottery/results', method: 'get' })
}

export function getLotteryHistory(params) {
  return request({ url: '/lottery/history', method: 'get', params })
}

export function getLotteryBets(params) {
  return request({ url: '/lottery/bets', method: 'get', params })
}

export function placeBet(data) {
  return request({ url: '/lottery/bet', method: 'post', data })
}

// ==================== 健康检查 ====================
export function healthCheck() {
  return request({ url: '/health', method: 'get' })
}
export function getUserStats() {
  return request({ url: '/user/stats', method: 'get' })
}
// ==================== 坐席管理（会员） ====================
export function getAgentList() {
  return request({ url: '/agent/list', method: 'get' })
}
export function createAgent(data) {
  return request({ url: '/agent/create', method: 'post', data })
}
export function updateAgent(data) {
  return request({ url: '/agent/update', method: 'post', data })
}
export function deleteAgent(data) {
  return request({ url: '/agent/delete', method: 'post', data })
}